<script lang="ts">
    import type { MenuInteractionEventPayload } from 'header/types';

    interface Props {
        definition: MenuInteractionEventPayload;
    }

    let { definition }: Props = $props();
</script>

<pre>{JSON.stringify(definition, null, 2)}</pre>
